import { useState, useEffect } from "react";
import Table from "../../components/table";
import styles from "../../styles/billing-setting.module.css";
import Heading from "../../components/shared-modules/Heading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faFilePen } from "@fortawesome/free-solid-svg-icons";
import AddBillingCodeModal from "../../components/billing-settings/add-billing-code";
import Button from "../../components/button-v1";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogBody,
} from "../../components/ui/dialog";
import {
  getBillingCodes,
  deleteBillingCode,
} from "../../services/case-manager/billing/setting";
import AlertDialog from "../../components/alert-dialogue";
import toast from "react-hot-toast";
function BillingPage() {
  const queryClient = useQueryClient();
  const [isOpen, setIsOpen] = useState(false);
  const [billingCodeId, setBillingCodeId] = useState(null);
  const [category, setCategory] = useState({
    ccm: false,
    rpm: true,
  });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [description, setDescription] = useState(null);
  const [isShowDesModalOpen, setIsShowDesModalOpen] = useState(false);
  const [billingType, setBillingType] = useState("RPM");
  const {
    data: billingCodes,
    error,
    isLoading: isBillingCodesLoading,
    refetch,
  } = useQuery(
    ["billing-codes", billingType],
    () => getBillingCodes(billingType),
    {
      enabled: !!billingType,
    }
  );

  const {
    mutate: deleteBillingCodeMutation,
    isLoading: isDeleteBillingCodeLoading,
  } = useMutation(() => deleteBillingCode(billingCodeId), {
    onSuccess: () => {
      toast.success("Billing code delete successfully");
      queryClient.invalidateQueries(["billing-codes"]);
      setBillingCodeId(null);
      setIsDeleteModalOpen(false);
    },
    onError: () => {
      toast.error("Could not delete billing code");
    },
  });

  const getColumns = () => {
    const commonColumns = [
      {
        key: "code",
        label: "Code",
      },
      { key: "category", label: "Category", alignLeft: true },
      { key: "price", label: "Price", alignLeft: true },
      {
        key: "description",
        label: "Description",
        alignLeft: true,
        render: (row) => (
          <p
            onClick={() => {
              setDescription(row?.description);
              setIsShowDesModalOpen((prev) => !prev);
            }}
            className={styles.description}
          >
            {row?.description}
          </p>
        ),
      },
    ];

    const actionsColumn = [
      {
        key: "actions",
        label: "Actions",
        alignLeft: false,
        sorting: false,
        sorting: false,
        render: (row) => (
          <div className={styles.actionButtonsContainer}>
            <Button
              variant="ghost"
              size="small"
              onClick={() => {
                setBillingCodeId(row.id);
                setIsOpen((prev) => !prev);
              }}
            >
              <FontAwesomeIcon icon={faFilePen} />
            </Button>

            {/* <Button
              variant="ghost"
              size="small"
              onClick={() => {
                setBillingCodeId(row.id);
                setIsDeleteModalOpen((prev) => !prev);
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button> */}
          </div>
        ),
      },
    ];

    return [...commonColumns, ...actionsColumn];
  };

  const handleDelete = () => {
    if (!billingCodeId) return;

    deleteBillingCodeMutation(billingCodeId);
  };

  const handleBillingTypeChange = (view) => {
    if (view === "ccm" && !category.rpm && category.ccm) {
      return;
    }
    if (view === "rpm" && !category.ccm && category.rpm) {
      return;
    }

    setCategory((prev) => ({
      ...prev,
      [view]: !prev[view],
    }));
  };

  useEffect(() => {
    if (category.ccm && category.rpm) {
      setBillingType("all");
    } else if (category.ccm) {
      setBillingType("CCM");
    } else if (category.rpm) {
      setBillingType("RPM");
    } else {
      setBillingType("all");
    }
  }, [category]);
  return (
    <div className={styles.billingContainer}>
      <Heading
        title={"Billing Settings"}
        bodyHeight="auto"
        // actions={
        //   [
        //     // <Button variant="ghost" onClick={() => setIsOpen((prev) => !prev)}>
        //     //   <img
        //     //     src="/icons/plus.svg"
        //     //     alt="category-icon"
        //     //     style={{ width: "14px", height: "14px" }}
        //     //   />
        //     //   Create Billing Code
        //     // </Button>,
        //   ]
        // }
        content={
          <div>
            {/* Tabs Section */}
            <div className={styles.tabsContainer}>
              <Button
                isRound={true}
                size="medium"
                variant={category.ccm ? "default" : "ghost"}
                onClick={() => handleBillingTypeChange("ccm")}
              >
                CCM
              </Button>
              <Button
                isRound={true}
                size="medium"
                variant={category.rpm ? "default" : "ghost"}
                onClick={() => handleBillingTypeChange("rpm")}
              >
                RPM
              </Button>
            </div>

            {/* Table Section */}
            <div className={styles.tableWrapper}>
              <Table
                columns={getColumns()}
                data={billingCodes}
                isRowClickable={false}
                showCheckboxes={false}
                horizontal={true}
                loading={isBillingCodesLoading}
                height={580}
              />
            </div>
          </div>
        }
      ></Heading>

      {/* Update Billing Code Modal */}
      <AddBillingCodeModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          setBillingCodeId(null);
        }}
        billingCodeId={billingCodeId}
        setBillingCodeId={setBillingCodeId}
        billingCode={billingCodes?.find(code => code.id === billingCodeId) || null}
      />

      {/* Delete Confirmation Modal */}
      <AlertDialog
        open={isDeleteModalOpen}
        setOpen={setIsDeleteModalOpen}
        title="Delete Billing Code"
        description="Are you sure you want to delete billing code?"
      >
        <Button
          variant="normal"
          size="default"
          onClick={() => {
            setIsOpen(false);
            setBillingCodeId(null);
          }}
        >
          Cancel
        </Button>
        <Button
          loading={isDeleteBillingCodeLoading}
          disabled={isDeleteBillingCodeLoading}
          variant="danger"
          size="default"
          onClick={() => handleDelete()}
        >
          Delete
        </Button>
      </AlertDialog>
      {/* Description Modal */}

      <Dialog
        open={isShowDesModalOpen}
        setOpen={() => setIsShowDesModalOpen(false)}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Description</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <div className={styles.content}>
              <textarea
                value={description}
                className={styles.textarea}
                autoFocus
                readOnly
              />
            </div>
          </DialogBody>
          <DialogFooter>
            <Button
              variant="normal"
              size="default"
              onClick={() => setIsShowDesModalOpen(false)}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default BillingPage;
